import { Injectable, Inject } from '@angular/core';
import { SimpleEventDispatcher } from 'strongly-typed-events';
import { Drivers } from '@ionic/storage';
import { Storage } from '@ionic/storage-angular';
import { Platform } from '@ionic/angular';
import { LogsService } from './utils/logs.service';
import { PLATFORM_ID } from '@angular/core';
import * as localforage from 'localforage';

@Injectable({
    providedIn: 'root'
})
export class StorageService {

    private ready = false;
    private onStorageReady = new SimpleEventDispatcher<boolean>();
    private storage: Storage = null;

    constructor(
        private plt: Platform,
        private logs: LogsService,
        @Inject(PLATFORM_ID) private platformId: object
    ) {
        // this.plt.ready().then(() => {
        //     this.init();
        // });
    }

    async init() {
        this.logs.info('[STORAGE] init');
        this.ready = false;

        try {
            localforage.config({
                driver: localforage.WEBSQL, // Force WebSQL; same as using setDriver()
                name: '__mychronos_kiosk',
                storeName: '_ionickv'
            });
        } catch {

        }

        this.storage = new Storage({
            name: '__mychronos_kiosk',
            driverOrder: [Drivers.IndexedDB],
            storeName: '_ionickv',
            dbKey: '_ionickey',
        });

        this.storage.create().then(async ready => {
            try {
                if (await localforage.length() > 0) {
                    // copy existing data into new, encrypted format
                    await localforage.iterate(async (value, key, iterationNumber) => {
                        await this.storage.set(key, value);
                    });

                    await localforage.clear();
                }
            } catch {}

            this.ready = true;
            this.onStorageReady.dispatch(true);
        });
    }

    async onReady() {
        return new Promise((resolve, reject) => {
            if (this.ready === true) {
                resolve(true);
            } else {
                this.onStorageReady.one(ready => {
                    resolve(true);
                });
            }
        });
    }

    async get(key): Promise<any> {
        return new Promise((resolve, reject) => {
            this.onReady().then(ready => {
                this.storage.get(key).then(result => {
                    resolve(result);
                }).catch(err => {
                    this.logs.info('[STORAGE] Error getting item', err);
                    reject(err);
                });
            });
        });
    }

    async set(key, value): Promise<any> {
        return new Promise((resolve, reject) => {
            this.onReady().then(ready => {
                this.storage.set(key, value).then(result => {
                    resolve(result);
                }).catch(err => {
                    this.logs.info('[STORAGE] Error setting item ' + key, err);
                    reject(err);
                });
            });
        });
    }

    async clear(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.onReady().then(ready => {
                this.storage.clear().then(res => {
                    resolve(true);
                }).catch(err => {
                    this.logs.info('[STORAGE] Error clear', err);
                    reject(err);
                });
            });
        });
    }

    async getDriver() {
        return new Promise((resolve, reject) => {
            this.onReady().then(ready => {
                resolve(this.storage.driver);
            });
        });
    }

}
